import { useId } from 'react';

interface TextInputProps {
  onChange: (value: string) => void;
  innerClassName?: string;
  placeholder?: string;
  className?: string;
  value?: string;
  label?: string;
  error?: string;
}

export function TextInput(props: TextInputProps) {
  const id = useId();

  const Label = () => {
    if (!props.label) return null;

    return (
      <label htmlFor={`textinput-${id}`} className="text-sm">
        {props.label}
      </label>
    );
  };

  const Error = () => {
    if (!props.error) return null;

    return (
      <p className="text-red-500 text-xs mt-1">
        {props.error}
      </p>
    );
  };

  return (
    <div className={props.className}>
      <Label />
      <input
        className={`${props.innerClassName} ${props.error && 'border border-red-500'} input`}
        onChange={(e) => props.onChange(e.target.value)}
        placeholder={props.placeholder}
        id={`textinput-${id}`}
        value={props.value}
        autoComplete="off"
        type="text"
      />
      <Error />
    </div>
  );
}